export const officialsSelectors = {
  getCommittees: state => state.officials.committees.results,
  getSearchedOfficials: state => state.officials.searchedOfficials,
  isFetching: state => state.officials.isFetching,
};
